module.exports = __webpack_public_path__ + "static/media/undefined-bold.6255332e.svg";